import {ACTION_TYPE} from '../../core/redux/actionType';
import {AppDocItem} from '../appDocItem';
import {ApiReducer, makeApiAction, makeApiReducer, RsaaTypes} from '../../core/redux/api/reduxStandardApiAction';
import {IAppState} from '../../core/redux/IAppState';
import {apiGetReleaseNotes} from '../../core/redux/api/endpoints';
import {hasTrippedBreaker, updateBreaker} from '../../core/redux/api/circuitBreaker/module';
import {addError, addLoading, getLoading, removeLoadingAndError} from '../../core/redux/api/module';
import {assoc} from '../../language/module';


export const KEY_ACTION = ACTION_TYPE.UPDATE_RELEASE_FAQ_REQUEST;

export const ACTIONS = [
  ACTION_TYPE.UPDATE_RELEASE_FAQ_REQUEST,
  ACTION_TYPE.UPDATE_RELEASE_FAQ_RESPONSE,
  ACTION_TYPE.UPDATE_RELEASE_FAQ_ERROR,
];


export const updateFaqsAction = (faqs: AppDocItem[]) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: apiGetReleaseNotes,
    body:     JSON.stringify(faqs),
    types:    ACTIONS.map(action => ({ type: action, meta: faqs })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
      || !!getLoading(state, KEY_ACTION , KEY_ACTION),
  },
);

const reducer: ApiReducer<any> = (state: IAppState, action: any, error: any, isLoading: boolean, payload: any) => {
  const faqs = action.meta.faqs as AppDocItem[];
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('faqs', faqs, noLoadingOrError);
}

export const updateFaqsReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);